import { z } from 'zod';

/**
 * Wire schemas for menu item API responses
 * These match the backend response format (snake_case)
 *
 * IMPORTANT: Backend stores:
 * - Timestamps as ISO string DATETIME, not Unix numbers
 * - Optional fields can be null, not just undefined
 */

/**
 * Menu item wire schema (matches backend response format)
 * Based on MenuItemReadSchema from Gateway
 */
export const menuItemWireSchema = z.object({
  id: z.string(),
  business_id: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  cover_photo_url: z.string().nullable().optional(),
  status: z.enum(['approved', 'pending']),
  created_by: z.string(),
  updated_by: z.string(),
  created_at: z.string(), // D1 DATETIME (ISO format)
  updated_at: z.string(), // D1 DATETIME (ISO format)
  business_name: z.string().optional(), // Populated via JOIN for search/display
  check_in_count: z.number().int().min(0).optional(),
  rating_distribution: z.object({
    not_for_me: z.number().int().min(0),
    okay: z.number().int().min(0),
    try_it: z.number().int().min(0),
    must_try: z.number().int().min(0),
  }).optional().nullable(),
});

export type MenuItemWire = z.infer<typeof menuItemWireSchema>;

/**
 * Paginated response wrapper schema
 * Matches createPaginatedResponseSchema from Gateway
 */
export const paginatedMenuItemResponseSchema = z.object({
  items: z.array(menuItemWireSchema),
  total: z.number().int().min(0),
  page: z.number().int().min(1),
  per_page: z.number().int().min(1).max(100),
  total_pages: z.number().int().min(0),
});

export type PaginatedMenuItemResponseWire = z.infer<typeof paginatedMenuItemResponseSchema>;
